export class CopiaContrato {
  // dados da cópia
  nuContrato: number;
  dtHoraAtendimento: string;
  dtHoraSolicitacao: string;
  qtDiasAtendimento: string;
  dtExpurgo: string;
  dsUrlDownload: string;
  cEmprOrigeContr: string;
  cdMsgStatus: string;
  dsMsgStatus: string;
  pdfBytes: string;

  // dados da transação
  nuTransacao?: string;
  nuProtocolo?: string;
  cdRetorno?: string;
  cdMsgemRetorno?: string;
  dsMsgemRetorno?: string;
  dsMsgemMainframeRetorno?: string;
  nuControle?: string;
  nuDocumento?: string;
  cdCtrlProcessamento?: string;
  textoAutenticacao?: string;
  cdIndcdTransacao?: string;
  lstMensagem?: Array<string>;
  nmUsuarioWebService?: string;
  cdSenhaWebService?: string;
  dsIdAplicacao?: string;
  dtBaseContrato?: string;
  dtBaseContratoFormatado?: string;
  cdCopiaAutenticada?: string;
  cdTipoSolicitacao?: string;
  cdTokenSessao?: string;
  cdTokenDossie?: string;
  cdStatusDispSolicit?: string;
  cdStatusRegra?: string;
  dsStatusRegra?: string;
  nuContratoFormatado?: string;
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/copiaContrato.ts